export enum PlantEndpoint {
  Base = '/plants',
  ExtIds = '/ext-ids',
  Search = '/search',
  Simple = '/simple',
  Filter = '/filter',
}
